import * as actionTypes from './actionTypes';

export const topnavUpdate=()=>{
    return { type: actionTypes.TOPNAV_UPDATE };
}


// WEBPACK FOOTER //
// ./src/redux/topnav/actions.js